module.exports = __webpack_public_path__ + "img/flowers_desktop.28d3fded.png";